// 求人一覧ページでのみ実行したいjsを定義する
$(function () {
  $('#q_municipality_prefecture_id_eq').change(function (e) {
    const prefectureId = $('option:selected', this).val()
    if (prefectureId) {
      updateMunicipalitySelectOptions(prefectureId)
    } else {
      $('#q_municipality_id_eq').empty()
    }
  })
})

function updateMunicipalitySelectOptions(prefectureId) {
  const $municipalitySelect = $('#q_municipality_id_eq')
  $municipalitySelect.empty()

  $municipalitySelect.append($('<option>'))
  gon.municipalities[prefectureId].forEach(function (municipality) {
    $municipalitySelect.append($('<option>').html(municipality.name).val(municipality.id))
  })
}